import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

export type ModalType = 'sale' | 'customer' | 'payment' | 'product' | 'delivery' | 'expense' | null;

interface QuickActionContextType {
  activeModal: ModalType;
  openModal: (type: ModalType) => void;
  closeModal: () => void;
}

const QuickActionContext = createContext<QuickActionContextType>({
  activeModal: null,
  openModal: () => {},
  closeModal: () => {},
});

export function useQuickAction() {
  return useContext(QuickActionContext);
}

export function QuickActionProvider({ children }: { children: ReactNode }) {
  const [activeModal, setActiveModal] = useState<ModalType>(null);

  const openModal = useCallback((type: ModalType) => setActiveModal(type), []);
  const closeModal = useCallback(() => setActiveModal(null), []);

  return (
    <QuickActionContext.Provider value={{ activeModal, openModal, closeModal }}>
      {children}
    </QuickActionContext.Provider>
  );
}